// extracted by mini-css-extract-plugin
module.exports = {"container":"AvatarViewer_container__GkebR","placeholder":"AvatarViewer_placeholder__ayTF2"};